import apiBase from "./apiBase";
const simpleGet = apiBase.simpleGet;
const simpleDelete = apiBase.simpleDelete;
const simplePost = apiBase.simplePost;
const parseHttpRequestError = apiBase.parseHttpRequestError;

/*****************************************************************
 * Audit API functions
 *****************************************************************/

function fetchAuditData(options) {
    // params is used for query string parameters
    var params = {
        
    }

    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/audits", options);
}

/*****************************************************************
 * Users API functions
 *****************************************************************/

 async function getUser(params) {
    const response = await apiBase.simpleGetAsync("/user", { params: params });

    return response.data;
}

function fetchUsers(options) {
    simpleGet("/users", options);
}

function saveUser(user, options) {
    simplePost("/user", user, options);
}

/*****************************************************************
 * Alerts API functions
 *****************************************************************/

function fetchAlerts(options) {
    simpleGet("/alerts", options);
}

function saveAlert(alert, options) {
    simplePost("/alerts", alert, options);
}

/*****************************************************************
 * Supplier Store API functions
 *****************************************************************/
function fetchSuppliers(options) {
    simpleGet("/suppliers", options);
}

function saveSupplier(data, options) {
    simplePost("/suppliers", data, options);
}

/*****************************************************************
 * Location Store API functions
 *****************************************************************/
function fetchLocationTypes(options) {
    simpleGet("/locations/locationtypes", options);
}

function fetchGeographicLocations(options) {
    simpleGet("/locations/geographiclocations", options);
}

function fetchSuiteNumbers(options) {
    simpleGet("/locations/suitenumbers", options);
}

function fetchRooms(options) {
    simpleGet("/locations/rooms", options);
}

function fetchDrawers(options) {
    simpleGet("/locations/drawers", options);
}

function saveLocationType(data, options) {
    simplePost("/locations/locationtypes", data, options);
}

function saveSuiteNumber(data, options) {
    simplePost("/locations/suitenumbers", data, options);
}

function saveRoom(data, options) {
    simplePost("/locations/rooms", data, options);
}

function saveDrawer(data, options) {
    simplePost("/locations/drawers", data, options);
}

/*****************************************************************
 * Venom Type Store API functions
 *****************************************************************/
function fetchVenomTypes(options) {
    simpleGet("/venomtypes", options);
}

function saveVenomType(data, options) {
    simplePost("/venomtypes", data, options);
}

/*****************************************************************
 * Species Store API functions
 *****************************************************************/
function fetchSpecies(options) {
    simpleGet("/species", options);
}

function saveSpecies(data, options) {
    simplePost("/species", data, options);
}

/*****************************************************************
 * Specimen Store API functions
 *****************************************************************/
/**
 * This function uses the old simpleGet implementation for new development use the 
 * specimenAPI.getSpecimen function instead - it supports await
 * @param {*} options 
 */
function fetchSpecimens(options) {
    simpleGet("/specimen", options);
}

function saveSpecimen(data, options) {
    // ensure we save blank weight value as NULL instead of making it default to zero
    if (data.ArrivalWeight === "") {
        delete data.ArrivalWeight;
    }

    simplePost("/specimen", data, options);
}

function saveSpecimenLocation(data, options){
    simplePost("/specimenlocation", data, options);
}

function deleteSpecimen(data, options){
    simpleDelete("/specimen", data, options);
}

async function fetchSpecimensInRoomAndRack(params) {
    const result = await apiBase.simpleGetAsync("/specimensinroomandrack", { params: params });

    return result.data;
}

async function moveSpecimensInRoomAndRack(data) {
    const result = await apiBase.simplePostAsync("/movespecimensinroomandrack", data);

    return result.data;
}

/*****************************************************************
 * Daily Husbandry API functions
 *****************************************************************/
function fetchDailyHusbandryTaskTypes(options){
    simpleGet("/dailyhusbandrytasktypes", options);
}

function fetchDailyHusbandryObservationTypes(options){
    simpleGet("/dailyhusbandryobservationtypes", options);
}

function saveDailyHusbandry(data, options){
    simplePost("/dailyhusbandry", data, options);
}

function fetchMedicalObservationTypes(options) {
    simpleGet("/medicalobservationtypes", options)
}

function saveMedicalObservation(data, options) {
    simplePost("/dailyhusbandry/medicalobservation", data, options);
}

function fetchHusbandryHistory(options){
    simpleGet("/dailyhusbandry", options);
}

function fetchLatestEventDetails(options) {
    simpleGet("/dailyhusbandry", options);
}

function fetchControlledOccurrenceTypes(options) {
    simpleGet("/controlledoccurrencetypes", options)
}

function saveControlledOccurrence(data, options) {
    simplePost("/dailyhusbandry/controlledoccurrence", data, options);
}

function fetchDangerousOccurrenceTypes(options) {
    simpleGet("/dangerousoccurrencetypes", options)
}

function fetchDailyHusbandryDashboardData(options) {
    simpleGet("/dailyhusbandry/dashboarddata", options)
}

function saveDangerousOccurrence(data, options) {
    simplePost("/dailyhusbandry/dangerousoccurrence", data, options);
}

function deleteDailyHusbandryRecord(data, options) {
    simpleDelete("/dailyhusbandry", data, options);
}


export default {
    getUser,
    fetchSuppliers,
    saveSupplier,
    saveLocationType,
    saveSuiteNumber,
    saveRoom,
    saveDrawer,
    fetchLocationTypes,
    fetchGeographicLocations,
    fetchSuiteNumbers,
    fetchRooms,
    fetchDrawers,
    fetchUsers,
    fetchVenomTypes,
    saveVenomType,
    parseHttpRequestError,
    saveUser,
    fetchSpecies,
    saveSpecies,
    fetchSpecimens,
    fetchSpecimensInRoomAndRack,
    moveSpecimensInRoomAndRack,
    saveSpecimen,
    deleteSpecimen,
    fetchAuditData,
    fetchAlerts,
    saveAlert,
    saveSpecimenLocation,
    fetchDailyHusbandryTaskTypes,
    fetchDailyHusbandryObservationTypes,
    saveDailyHusbandry,
    fetchMedicalObservationTypes,
    saveMedicalObservation,
    fetchHusbandryHistory,
    fetchLatestEventDetails,
    fetchControlledOccurrenceTypes,
    saveControlledOccurrence,
    fetchDangerousOccurrenceTypes,
    saveDangerousOccurrence,
    deleteDailyHusbandryRecord,
    fetchDailyHusbandryDashboardData
};
